// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { CrisisCallCardProperties_abstract } from './../abstract/SagaSchema/CrisisCallCardProperties_abstract';
export class CrisisCallCardProperties extends CrisisCallCardProperties_abstract {}
